import React from "react";
import { motion } from 'framer-motion';
import { Link } from "gatsby";
import LazyLoad from 'react-lazyload';

export default function ColumnLayout(props) {
  const { header, subHeader, services, classes } = props.data;
  return (
    <div className="section-gap other-services" id={props.id ? props.id : ''}>
      <div className={`section-title ${classes}`}>
        <div className="container">
          {header && <h2>{header}</h2>}
          {subHeader && <p>{subHeader}</p>}
        </div>
      </div>
      <div className="column-layout-section">
        <div className="container">
          <div className="row d-flex flex-wrap justify-center">
            {services && services.map((service, index) => {
              return (<div className="col column-item" key={index}>
                <div className="item-inner button-on-hover">
                  <div className="grid-icon">
                    <i><LazyLoad><img src={service.image} title={service.title} alt={service.alt} /></LazyLoad></i>
                  </div>
                  <h3 className="h5">{service.header}</h3>
                  <p>{service.content}</p>
                  <div className="button-hover">
                    <Link to={service.link} className="button button-small button-black right-arrow">Read More</Link>
                  </div>
                </div>
              </div>);
            })}
          </div>
        </div>
      </div>
    </div>
  );
}